<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_SPECIAL_TERR_ID'
        )
      }"
    >
      <select
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_SPECIAL_TERR_ID')
        "
        v-model="project.UF_SPECIAL_TERR_ID"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in directory.sp_products_in_special_territories"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_SPECIAL_TERR_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "SpecialPlace",
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_products_in_special_territories"])
      .then(() => {}, this);
  },
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
